import { useEffect, useState } from "react";

import { useAppDispatch } from "../../../redux/useAppDispatch";
import { switchOffUser, switchOnUser } from "../../../redux/SettingModule/UsersPage/UsersAction";
import { Switch } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

function ActionColumnSettings(props: any) {
  const dispatch = useAppDispatch();
  const [switchStatus, setSwitchStatus] = useState(props.record.isActive);
  const loading = useSelector((state: RootState) => state.UsersPageState.switchUserLoading);
  useEffect(() => {
    setSwitchStatus(props.record.isActive);
  }, [props.record.isActive]);
  return (
    <div className="d-flex gap-2 w-100 justify-content-center">
      {/* <InfoButton /> */}
      <Switch
        value={switchStatus}
        loading={loading}
        onChange={async (checked) => {
          if (checked) {
            try {
              await dispatch(switchOnUser({ id: props.record.idUser })).unwrap();
              setSwitchStatus(true);
            } catch (error) {
              console.log("Error switching on user:", error);
              setSwitchStatus(false);
            }
          } else {
            try {
              await dispatch(switchOffUser({ id: props.record.idUser })).unwrap();
              setSwitchStatus(false);
            } catch (error) {
              setSwitchStatus(true);
            }
          }
        }}
      />
      {/* <DeleteButton
        onClick={() => {
          dispatch(setCurrentRecord(props.record));
          dispatch(openDeleteUsersModal());
        }}
      /> */}
    </div>
  );
}

export default ActionColumnSettings;
